module.exports = __webpack_public_path__ + "img/trans_energi_logistik.8d02974f.png";